<template>
  <div id="side-menu-container"
       class="side--menu--container">
    <div class="dmb-overlay"
         @click="$emit('close')">
      &nbsp;
    </div>
    <div id="side-menu"
         class="side--menu">
      <div id="items-container">
        <template v-for="(item) in items">
          <div :key="item.key" class="items-container">
            <div :class="currentItem === item.key ? 'current-item' : ''"
                 class="header1"
                 @click="itemClick(item)">{{ item.title }}
            </div>
            <div v-if="item.items && selectedItem === item.key">
              <div v-if="item.key === 'menuUser'"
                   class="first router--link">
                <div class="header2">{{ $store.getters.nameForMenu }}</div>
              </div>
              <div v-for="(subItem, subIndex) in item.items"
                   :key="item.key + subIndex"
                   :class="{'first': subIndex === 0}"
                   class="router--link"
                   @click.stop="$emit('navigate', subItem.path)">
                <div class="header2">{{ subItem.title }}</div>
                <div class="menu--text">{{ subItem.description }}</div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div id="side-menu-contacts">
        <v-container class="py-0" fluid>
          <a :href="'tel:' + maklerService.phoneClickable">
            <v-row class="contact-entry flex-nowrap">
              <div>
                <img class="iconContact"
                     src="@/assets/svg/ic_telefon.svg"
                     alt="Kontakt Telefon">
              </div>
              <div>
                <span>{{ maklerService.phone }}</span> <br>
                <span>Makler-Hotline</span>
              </div>
            </v-row>
          </a>
          <a href="mailto:maklerservice@dmb-rechtsschutz.de">
            <v-row class="contact-entry flex-nowrap">
              <div>
                <img class="iconContact"
                     src="@/assets/svg/ic_mail.svg"
                     alt="Kontakt EMail">
              </div>
              <div>
                <span>maklerservice@dmb-rechtsschutz.de</span> <br>
                <span>Maklerservice</span>
              </div>
            </v-row>
          </a>
        </v-container>
      </div>
    </div>
    <v-icon size="36"
            class="black87"
            @click="$emit('close')">close</v-icon>
  </div>
</template>

<script>
  export default {
    name: 'SiteMenuDrawer',
    props: {
      items: {
        type: Array,
        required: true
      },
      currentItem: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        selectedItem: ""
      };
    },
    computed: {
      maklerService() {
        return this.$store.state.staticPagesContent.AboutUnternehmenMaklerBox;
      }
    },
    mounted () {
      //remove outer scroll-bar
      let html = document.documentElement;
      html.classList.add("no--scrolling");
    },
    beforeDestroy () {
      let html = document.documentElement;
      html.classList.remove("no--scrolling");
    },
    methods: {
      close() {
        this.$emit('close');
      },
      itemClick(item) {
        this.selectedItem = item.key;
        if (!item.items) this.$emit('navigate', item.path);
      }
    }
  };
</script>
<style>
.side--menu--container {
  position: fixed;
  top: 0;
  z-index: 18;
  width: 100%;
  min-height: 100vh;
  height: 100vh;
}

.side--menu--container .dmb-overlay {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  background-color: #212121;
  opacity: 0.46;
}

.side--menu {
  background-color: #FFFFFF;
  padding: 30px 36px 40px 16px;
  height: 100%;
  position: absolute;
  top: 0;
  max-width: 400px;
  min-width: 400px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.side--menu--container .v-icon {
  position: absolute;
  top: 10px;
  left: 348px;
  cursor: pointer;
}

.side--menu .header1 {
  font-size: 24px !important;
  font-weight: 400;
  color: #002C76;
  cursor: pointer;
  margin-top: 20px;
}

.side--menu .header1.current-item {
  font-weight: 500;
}

.side--menu .router--link {
  margin-left: 16px;
}

.side--menu .header2 {
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, .87);
  margin: 16px 0 8px 0;
}

.side--menu .menu--text {
  font-size: 14px;
  font-weight: normal;
  color: rgba(0, 0, 0, .38);
}

.side--menu .header1:hover, .side--menu .router--link:hover .header2, .side--menu .router--link:hover .menu--text {
  color: #0085CF;
  cursor: pointer;
}

.side--menu .router--link:not(.first)::before, .side--menu #side-menu-contacts::before {
  display: block;
  content: "";
  border-top: 1px solid rgba(0, 0, 0, .38);
  width: 100%;
  margin: 16px 0 20px 0;
}

.side--menu #side-menu-contacts {
  margin-top: 40px;
  margin-bottom: 70px !important;
}

.side--menu #side-menu-contacts img {
  height: 40px;
  margin-right: 20px;
}

.side--menu #side-menu-contacts span:first-child {
  font-size: 12pt;
}

.side--menu #side-menu-contacts span:last-child {
  color: rgba(0, 0, 0, .38);
}

.side--menu #side-menu-contacts .contact-entry {
  margin-top: 16px;
}

.side--menu #side-menu-contacts a {
  color: rgba(0, 0, 0, .87);
}
</style>
